<template>
  <div class="wrapper">
    <ul>
      <li v-for="cmt of comments"
          :key="cmt.id"
          class="cmt-item border-bottom-1px">
        <div class="portrait">
          <img width="32" height="32" :src="cmt.portrait">
        </div>
        <div class="content">
          <h1 class="name">{{cmt.userName}}</h1>
          <div class="text" v-html="decodeFace(cmt.content)"></div>
          <div class="time">{{formatTime(cmt.createAt)}}</div>
          <cmt-child-list :children="cmt.children" v-if="cmt.children.length"/>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import momentMixin from 'common/mixins/moment'
  import faceMixin from 'common/mixins/face'
  import CmtChildList from './CmtChildList'

  export default {
    name: 'CommentList',
    mixins: [momentMixin, faceMixin],
    components: {
      CmtChildList
    },
    props: {
      comments: Array
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~stylus/variable.styl'

  .wrapper
    padding: 0 12px
    .cmt-item
      display: flex
      padding: 12px 0
      .portrait
        flex: 0 0 28px
        width: 32px
        margin-right: 12px
        img
          height: auto
          border-radius: 50%
      .content
        position: relative
        flex: 1
        .name
          margin-bottom: 8px
          line-height: 12px
          font-size: $fontsize-medium
          color: $color-accent-text
        .text
          line-height: 24px
          color: $color-primary-text
          font-size: $fontsize-medium
        .time
          position: absolute
          top: 0
          right: 0
          line-height: 12px
          font-size: $fontsize-small
          color: $color-second-text
</style>
